import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIElements } from "gameiom/wrapper/wrapper-data";

export class AgsAccountsButtonControl extends ButtonControl {
    public setEnabled(enabled: boolean): void {
        const displayAccountsButton: boolean = gameiomModel.displayButtons.get(UIElements.accountsButton);
        this.setVisible(displayAccountsButton);
        super.setEnabled(enabled);
    }

    public setVisible(displayDepositPageButton: boolean) {
        this.button.setVisible(displayDepositPageButton);
    }

    protected onClick(): void {
        gameWrapper.gotoAccountsPage();
        super.onClick();
    }
}
